import disclaimerHeroBg from "../assets/disclamerhero.png";

function Disclaimer() {
  return (
    <div className="bg-white">
      <section
        className="relative isolate flex min-h-[180px] items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat sm:min-h-[200px] md:min-h-[220px]"
        style={{ backgroundImage: `url(${disclaimerHeroBg})` }}
        aria-labelledby="disclaimer-hero-heading"
      >
        <div
          className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/50 to-ink/35"
          aria-hidden
        />
        <div className="relative z-10 mx-auto max-w-7xl px-4 py-6 text-center sm:px-8 sm:py-8 md:px-10 lg:px-8">
          <h1
            id="disclaimer-hero-heading"
            className="text-3xl font-semibold tracking-tight text-white sm:text-4xl md:text-5xl"
          >
            Disclaimer
          </h1>
        </div>
      </section>

      <section
        className="relative overflow-hidden bg-white py-12 sm:py-16 lg:py-20"
        aria-labelledby="disclaimer-content-heading"
      >
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-light/25 to-transparent"
          aria-hidden
        />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
          <article className="rounded-2xl border border-brand/10 bg-white p-6 shadow-[0_16px_40px_-24px_rgba(30,22,51,0.22)] ring-1 ring-brand/5 sm:p-8 lg:p-10">
          <p className="text-sm text-ink/60">Last updated: May 02, 2026</p>

          <h2
            id="disclaimer-content-heading"
            className="mt-8 text-2xl font-bold tracking-tight text-ink sm:text-3xl"
          >
            Interpretation and Definitions
          </h2>

          <h3 className="mt-8 text-lg font-semibold text-ink">Interpretation</h3>
          <p className="mt-3 text-base leading-relaxed text-ink/80">
            The words of which the initial letter is capitalized have meanings defined under the
            following conditions. The following definitions shall have the same meaning regardless
            of whether they appear in singular or in plural.
          </p>

          <h3 className="mt-8 text-lg font-semibold text-ink">Definitions</h3>
          <p className="mt-3 text-base leading-relaxed text-ink/80">
            For the purposes of this Disclaimer:
          </p>
          <dl className="mt-4 space-y-4 text-base leading-relaxed text-ink/80">
            <div>
              <dt className="font-semibold text-ink">Company</dt>
              <dd className="mt-1 pl-0 sm:pl-0">
                (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or
                &quot;Our&quot; in this Disclaimer) refers to Altus Online School.
              </dd>
            </div>
            <div>
              <dt className="font-semibold text-ink">Service</dt>
              <dd className="mt-1">refers to the Website.</dd>
            </div>
            <div>
              <dt className="font-semibold text-ink">You</dt>
              <dd className="mt-1">
                means the individual accessing the Service, or the company, or other legal entity
                on behalf of which such individual is accessing or using the Service, as applicable.
              </dd>
            </div>
            <div>
              <dt className="font-semibold text-ink">Website</dt>
              <dd className="mt-1">
                refers to the Altus Online School website at{" "}
                <a
                  href="https://www.altusschool.com"
                  className="font-medium text-brand underline decoration-brand/30 underline-offset-2 transition hover:text-brand-dark"
                >
                  www.altusschool.com
                </a>
                .
              </dd>
            </div>
          </dl>

          <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">Disclaimer</h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
            <p>
              The information contained on the Service is for general information purposes only.
            </p>
            <p>
              The Company assumes no responsibility for errors or omissions in the contents of the
              Service.
            </p>
            <p>
              In no event shall the Company be liable for any special, direct, indirect,
              consequential, or incidental damages or any damages whatsoever, whether in an action
              of contract, negligence or other tort, arising out of or in connection with the use of
              the Service or the contents of the Service. The Company reserves the right to make
              additions, deletions, or modifications to the contents on the Service at any time
              without prior notice.
            </p>
            <p>
              The Company does not warrant that the Service is free of viruses or other harmful
              components.
            </p>
          </div>

          <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
            External Links Disclaimer
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
            <p>
              The Service may contain links to external websites that are not provided or
              maintained by or in any way affiliated with the Company.
            </p>
            <p>
              Please note that the Company does not guarantee the accuracy, relevance, timeliness, or
              completeness of any information on these external websites.
            </p>
          </div>

          <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
            Errors and Omissions Disclaimer
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
            <p>
              The information given by the Service is for general guidance on matters of interest
              only. Even if the Company takes every precaution to insure that the content of the
              Service is both current and accurate, errors can occur. Plus, given the changing nature
              of laws, rules and regulations, there may be delays, omissions or inaccuracies in the
              information contained on the Service.
            </p>
            <p>
              The Company is not responsible for any errors or omissions, or for the results
              obtained from the use of this information.
            </p>
          </div>

          <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
            Fair Use Disclaimer
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
            <p>
              The Company may use copyrighted material which has not always been specifically
              authorized by the copyright owner. The Company is making such material available for
              criticism, comment, news reporting, teaching, scholarship, or research.
            </p>
            <p>
              The Company believes this constitutes a &quot;fair use&quot; of any such copyrighted
              material as provided for in Indian Copyright law.
            </p>
            <p>
              If You wish to use copyrighted material from the Service for your own purposes that go
              beyond fair use, You must obtain permission from the copyright owner.
            </p>
          </div>

          <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
            Views Expressed Disclaimer
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
            <p>
              The Service may contain views and opinions which are those of the authors and do not
              necessarily reflect the official policy or position of any other author, agency,
              organization, employer or company, including the Company.
            </p>
            <p>
              Comments published by users are their sole responsibility and the users will take full
              responsibility, liability and blame for any libel or litigation that results from
              something written in or as a direct result of something written in a comment. The
              Company is not liable for any comment published by users and reserve the right to
              delete any comment for any reason whatsoever.
            </p>
          </div>

          <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
            No Responsibility Disclaimer
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
            <p>
              The information on the Service is provided with the understanding that the Company is
              not herein engaged in rendering legal, accounting, tax, or other professional advice
              and services. As such, it should not be used as a substitute for consultation with
              professional accounting, tax, legal or other competent advisers.
            </p>
            <p>
              In no event shall the Company or its suppliers be liable for any special, incidental,
              indirect, or consequential damages whatsoever arising out of or in connection with your
              access or use or inability to access or use the Service.
            </p>
          </div>

          <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">
            &quot;Use at Your Own Risk&quot; Disclaimer
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/80">
            <p>
              All information in the Service is provided &quot;as is&quot;, with no guarantee of
              completeness, accuracy, timeliness or of the results obtained from the use of this
              information, and without warranty of any kind, express or implied, including, but not
              limited to warranties of performance, merchantability and fitness for a particular
              purpose.
            </p>
            <p>
              The Company will not be liable to You or anyone else for any decision made or action
              taken in reliance on the information given by the Service or for any consequential,
              special or similar damages, even if advised of the possibility of such damages.
            </p>
          </div>

          <h2 className="mt-12 text-2xl font-bold tracking-tight text-ink sm:text-3xl">Contact Us</h2>
          <p className="mt-6 text-base leading-relaxed text-ink/80">
            If you have any questions about this Disclaimer, You can contact Us:
          </p>
          <p className="mt-4 text-base leading-relaxed text-ink/80">
            <span className="font-semibold text-ink">By email:</span>{" "}
            <a
              href="mailto:info@altusonlineschool.com"
              className="font-medium text-brand underline decoration-brand/30 underline-offset-2 transition hover:text-brand-dark"
            >
              info@altusonlineschool.com
            </a>
          </p>
          </article>
        </div>
      </section>
    </div>
  );
}

export default Disclaimer;
